export const formatDate = (date: Date, options?: Intl.DateTimeFormatOptions) =>
  date.toLocaleDateString('pt-br', { ...options });

export const formatRequirementDate = (date: Date) =>
  formatDate(date, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

const DATE_LABELS_TYPE = {
  year: 'year',
  month: 'month',
  day: 'day',
  hour: 'hour',
  minute: 'minute',
  second: 'second',
} as const;

const DATE_LABELS = (value: number) => {
  const values = {
    [DATE_LABELS_TYPE.year]: value > 1 ? ' anos' : ' ano',
    [DATE_LABELS_TYPE.month]: value > 1 ? ' meses' : ' mês',
    [DATE_LABELS_TYPE.day]: value > 1 ? ' dias' : ' dia',
    [DATE_LABELS_TYPE.hour]: 'h',
    [DATE_LABELS_TYPE.minute]: 'min',
    [DATE_LABELS_TYPE.second]: 's',
  };
  return values;
};

export function formatDifferenceBetweenDates(
  firstDate?: string,
  secondDate?: string,
  lengthDifferenceDates?: number
) {
  const differenceInMilliseconds = Math.abs(
    new Date(firstDate || '').getTime() - new Date(secondDate || '').getTime()
  );

  const seconds = {
    value: Math.trunc((differenceInMilliseconds / 1000) % 60),
    type: DATE_LABELS_TYPE.second,
  };
  const minutes = {
    value: Math.trunc((differenceInMilliseconds / (1000 * 60)) % 60),
    type: DATE_LABELS_TYPE.minute,
  };
  const hours = {
    value: Math.trunc((differenceInMilliseconds / (1000 * 60 * 60)) % 24),
    type: DATE_LABELS_TYPE.hour,
  };
  const days = {
    value: Math.trunc((differenceInMilliseconds / (1000 * 60 * 60 * 24)) % 30),
    type: DATE_LABELS_TYPE.day,
  };
  const months = {
    value: Math.trunc(
      (differenceInMilliseconds / (1000 * 60 * 60 * 24 * 30)) % 12
    ),
    type: DATE_LABELS_TYPE.month,
  };
  const years = {
    value: Math.trunc(
      differenceInMilliseconds / (1000 * 60 * 60 * 24 * 30 * 12)
    ),
    type: DATE_LABELS_TYPE.year,
  };

  const differenceDates = [years, months, days, hours, minutes, seconds]
    .filter(d => d.value > 0)
    .slice(0, lengthDifferenceDates);

  const differenceFormatted = () =>
    `${differenceDates[0]?.value}${
      DATE_LABELS(differenceDates[0]?.value)[differenceDates[0]?.type]
    }` +
    ` ${differenceDates[1]?.value || ''}${
      DATE_LABELS(differenceDates[1]?.value)[differenceDates[1]?.type] || ''
    }`;

  return differenceDates.length > 0 ? differenceFormatted() : '0h 00min';
}

export const ONE_DAY_IN_SECONDS = 24 * 60 * 60;
export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const getDaysAgo = (daysAgo: number) => {
  const date = new Date();

  date.setDate(date.getDate() - daysAgo);
  return new Date(date).toISOString();
};

export const getNumberOfDays = (date: string) => {
  const currentDate = new Date();
  const dateInAnalysis = new Date(date);

  if (!date) return 0;

  return new Date(currentDate.getTime() - dateInAnalysis.getTime()).getDate();
};

export function calculateFinishDate<T extends Date | null>(date: T): T {
  date?.setHours(23);
  date?.setMinutes(59);
  date?.setSeconds(59);
  date?.setMilliseconds(999);

  return date;
}

export function diffInDays(date: string) {
  const diffInMilliseconds = new Date(date).getTime() - new Date().getTime();
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

  return diffInDays;
}
